"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var nodeEnv = process.env.NODE_ENV || process.env.REACT_APP_NODE_ENV; // Set environment variables

var port = process.env.PORT || process.env.REACT_APP_PORT || "3000";
var host = process.env.HOST || process.env.REACT_APP_HOST || "http://localhost:" + port;
var domain = process.env.DOMAIN || process.env.REACT_APP_DOMAIN || "localhost"; // 'schoolofcode.io';
// api

var apiUrl = process.env.SOC_API_URL || process.env.REACT_APP_SOC_API_URL || "http://localhost:8080"; // hack - docker host uri for api

var apiUrlForServer = process.env.SOC_API_URL || process.env.REACT_APP_SOC_API_URL || "http://localhost:8080"; // AWS

var awsRegion = process.env.AWS_REGION || process.env.REACT_APP_SAWS_REGION || "eu-west-1";
var contentBucket = process.env.AWS_S3_BUCKET_CONTENT || process.env.REACT_APP_AWS_S3_BUCKET_CONTENT || "soc-platform-content-dev";
var s3Url = "https://s3." + awsRegion + ".amazonaws.com"; // SoC Services

var socUploadContentUrl = process.env.SOC_UPLOAD_CONTENT_URL || process.env.REACT_APP_SOC_UPLOAD_CONTENT_URL || "http://localhost:3080";
var config = {
  nodeEnv: nodeEnv,
  port: port,
  host: host,
  domain: domain,
  secret: process.env.SOC_SECRET || process.env.REACT_APP_SOC_SECRET || "7EJ+lsMk4(T:4N;LX7Ohgj3&69M9?S",
  routes: {
    health: "/health",
    login: "/login",
    home: "/",
    passwordReset: "/password-reset",
    passwordResetEntry: "/password-reset-entry",
    logout: "/logout",
    register: "/register",
    leaderboard: "/leaderboard",
    game: "/game",
    groups: "/groups",
    gameAvatar: "/game-avatar",
    metrics: "/metrics",
    rooms: "/rooms",
    tasks: "/tasks",
    challenges: "/challenges",
    users: "/users",
    profile: "/profile",
    characterGallery: "/character-gallery",
    index: "/",
    courseLibrary: "/course-library",
    floppyCharacter: "/floppy-character",
    guide: "/guide",
    group: "/group",
    connections: "/connections",
    characters: "/characters",
    feedback: "/feedback",
    api: "/api"
  },
  aws: {
    region: awsRegion,
    s3: {
      url: s3Url,
      // TODO: change to general user resources/assets rather than svg and images for all users in separate buckets
      contentBucket: contentBucket
    }
  },
  // TODO: import these from environment or existing apps sp they reflect those urls
  // well, this is sort of client service urls.
  serviceUrls: {
    // TODO: currently svg-converter, rename to something else
    uploadContent: {
      url: socUploadContentUrl,
      // TODO: change throughout app away from character specific
      saveContentUrl: socUploadContentUrl + "/content",
      loadContentUrl: socUploadContentUrl + "/content",
      loadFileOptionsUrl: socUploadContentUrl + "/fs"
    },
    // soc-api
    // TODO: generate routes instead of hardcoding in each apiUrl
    api: {
      url: apiUrl,
      actions: apiUrl + "/actions",
      challenges: apiUrl + "/challenges",
      characters: apiUrl + "/characters",
      connections: apiUrl + "/connections",
      feedback: apiUrl + "/feedback",
      friends: apiUrl + "/friends",
      groups: apiUrl + "/groups",
      guide: apiUrl + "/guide",
      health: apiUrl + "/health",
      login: apiUrl + "/login",
      logout: apiUrl + "/logout",
      passwordReset: apiUrl + "/password-reset",
      passwordResetEntry: apiUrl + "/password-reset-entry",
      avatar: apiUrl + "/users/avatar",
      rooms: apiUrl + "/rooms",
      tasks: apiUrl + "/tasks",
      users: apiUrl + "/users",
      // TODO: get rid
      serverRooms: apiUrlForServer + "/rooms",
      server: "" + apiUrlForServer,
      shop: apiUrl + "/shop"
    }
  }
};
exports.default = config;